import request from '@/utils/request'

export function loginFetch(data) {
  return request({
    url: '/v1/passport/login',
    method: 'post',
    data
  })
}

export function registryFetch(data) {
  return request({
    url: '/v1/passport/register/info',
    method: 'post',
    data
  })
}

export function getUserInfo(data) {
  return request({
    url: '/v1/passport/user-info/user-detail',
    method: 'get',
    params: data
  })
}


export function updateUserInfo(data) {
  return request({
    url: '/v1/passport/user-info/change-own-info',
    method: 'post',
    data
  })
}

export function resetPasswordFetch(data) {
  return request({
    url: '/v1/passport/login/password',
    method: 'post',
    data
  })
}

export function sendCode(data) {
  return request({
    url: '/v1/push/sms',
    method: 'post',
    data
  })
}

export function logout(data) {
  return request({
    url: '/v1/passport/login-out',
    method: 'post',
    data
  })
}
